module.exports = __webpack_public_path__ + "media/bootstrap-icons/kanban-dce50fd5.svg";